import type { CareerJobResponse } from "./types/career-job-response";
import type { JobDetailsData } from "./types/job-details-data";

function mapJobToJobDetailsData(
  response: CareerJobResponse,
): JobDetailsData | null {
  const jobId = response.jobId;

  if (jobId == null || !Number.isInteger(jobId) || jobId < 1) {
    return null;
  }

  if (response.jobActive === false) {
    return null;
  }

  const jobTitle = response.jobTitle?.trim();
  if (!jobTitle) {
    return null;
  }

  return {
    employmentType: response.employmentType ?? "",
    expirationDate: response.expirationDate ?? null,
    franchiseNumber: response.franchiseNumber ?? "",
    jobActive: response.jobActive ?? true,
    jobDescription: response.jobDescription ?? "",
    jobId,
    jobPostDate: response.jobPostDate ?? "",
    jobTitle,
    jobUrl: response.jobUrl ?? "",
    salaryMax: response.salaryMax ?? 0,
    salaryMin: response.salaryMin ?? 0,
    salaryUnit: response.salaryUnit ?? "",
  };
}

export { mapJobToJobDetailsData };
